import { toast } from "react-toastify";
import dataService from "../../helpers/dataService";
import { initialState } from "../reducers/rcproFormReducers";

export const rcproFormActions = (state, dispatch, props) => {
  const resetFormState = () => {
    dispatch({
      type: "RESET_FORM_DATA",
      payload: null,
    });
  };

  const initFormState = (apiState) => {
    updateApiData(apiState);
    let newStateData = { ...initialState.formData };
    Object.keys(newStateData).forEach((stkey, key) => {
      var section = newStateData[stkey];
      Object.keys(section).forEach((inpkey) => {
        if (typeof apiState[inpkey] !== "undefined") {
          newStateData[stkey][inpkey] = apiState[inpkey];
        }
      });
    });
    console.log("newStateData", newStateData);
    updateFormData(newStateData);
  };

  const updateApiData = (newObject) => {
    dispatch({
      type: "UPDATE_API_DATA",
      payload: newObject,
    });
  };
  const updateFormData = (newObject) => {
    dispatch({
      type: "UPDATE_FORM_DATA",
      payload: newObject,
    });
  };

  const updateHeadOfficeInfosInputs = (newObject) => {
    dispatch({
      type: "UPDATE_HEADOFFICE_INFOS_INPUTS",
      payload: newObject,
    });
  };
  const updateGlobalInfosInputs = (newObject) => {
    dispatch({
      type: "UPDATE_GLOBAL_INFOS_INPUTS",
      payload: newObject,
    });
  };
  const updateActiviteInputs = (newObject) => {
    dispatch({
      type: "UPDATE_ACTIVITE_INPUTS",
      payload: newObject,
    });
  };
  const updateRCPROGlobalInfoInputs = (newObject) => {
    dispatch({
      type: "UPDATE_RCPRO_GLOBAL_INFO_INPUTS",
      payload: newObject,
    });
  };

  const updateRCPROSpecificInfoInputs = (newObject) => {
    dispatch({
      type: "UPDATE_RCPRO_SPECIFIC_INFO_INPUTS",
      payload: newObject,
    });
  };

  const updateRCPROGlobalInfo2Inputs = (newObject) => {
    dispatch({
      type: "UPDATE_RCPRO_GLOBAL_INFO2_INPUTS",
      payload: newObject,
    });
  };

  const updateRCPROCommentInputs = (newObject) => {
    dispatch({
      type: "UPDATE_RCPRO_COMMENT_INPUTS",
      payload: newObject,
    });
  };

  const updateErrors = (err) => {
    dispatch({
      type: "UPDATE_ERRORS",
      payload: err,
    });
  };
  const updateSaving = (isSaving) => {
    dispatch({
      type: "UPDATE_SAVING",
      payload: isSaving,
    });
  };

  const saveForm = async () => {
    let { apiData, formData } = state.rcproForm;
    let { establishmentId } = apiData;

    updateErrors({});
    updateSaving(true);

    const globalInfosData = {
      id: establishmentId,
      ...formData.globalInfosInputs,
    };

    const activiteData = {
      id: establishmentId,
      ...formData.activiteInputs,
    };

    const rcproGlobalInfoData = {
      id: establishmentId,
      ...formData.rcproGlobalInfoInputs,
    };

    const rcproSpecificInfoData = {
      id: establishmentId,
      ...formData.rcproSpecificInfoInputs,
    };

    const rcproGlobalInfo2Data = {
      id: establishmentId,
      ...formData.rcproGlobalInfo2Inputs,
    };

    const rcproCommentData = {
      id: establishmentId,
      ...formData.rcproCommentInputs,
    };

    let postData = {
      establishmentId,
      userId: state.auth.user.id,
      validationSchema: "",
      establishmentData: {
        ...globalInfosData,
        ...activiteData,
        ...rcproGlobalInfoData,
        ...rcproSpecificInfoData,
        ...rcproGlobalInfo2Data,
        ...rcproCommentData,
      },
    };

    const postDataGlobalInfos = {
      ...postData,
      validationSchema: "globalInfosSchema",
    };
    const postDataActivite = {
      ...postData,
      validationSchema: "RCPROActiviteSchema",
    };
    const postDataRCPROGlobalInfo = {
      ...postData,
      validationSchema: "RCPROGlobalInfoSchema",
    };
    const postDataRCPROSpecificInfo = {
      ...postData,
      validationSchema: "RCPROSpecificInfoSchema",
    };
    const postDataRCPROGlobalInfo2 = {
      ...postData,
      validationSchema: "RCPROGlobalInfoInputs2Schema",
    };
    const postDataRCPROComment = {
      ...postData,
      validationSchema: "RCPROCommentSchema",
    };

    const res0 = await saveBlockData(postDataGlobalInfos).catch((err) => ({
      errors: err,
    }));
    if (res0.errors) {
      updateErrors(res0.errors);
      updateSaving(false);
      return false;
    }
    const res1 = await saveBlockData(postDataActivite).catch((err) => ({
      errors: err,
    }));
    if (res1.errors) {
      updateErrors(res1.errors);
      updateSaving(false);
      return false;
    }
    const res2 = await saveBlockData(postDataRCPROGlobalInfo).catch((err) => ({
      errors: err,
    }));
    if (res2.errors) {
      updateErrors(res2.errors);
      updateSaving(false);
      return false;
    }
    const res3 = await saveBlockData(postDataRCPROSpecificInfo).catch(
      (err) => ({
        errors: err,
      })
    );
    if (res3.errors) {
      updateErrors(res3.errors);
      updateSaving(false);
      return false;
    }
    const res4 = await saveBlockData(postDataRCPROGlobalInfo2).catch((err) => ({
      errors: err,
    }));
    if (res4.errors) {
      updateErrors(res4.errors);
      updateSaving(false);
      return false;
    }
    const res5 = await saveBlockData(postDataRCPROComment).catch((err) => ({
      errors: err,
    }));
    if (res5.errors) {
      updateErrors(res5.errors);
      updateSaving(false);
      return false;
    }
    updateSaving(false);
    toast.success("Vos modifications ont bien été enregistrées");
    toast.success(
      "Retrouvez le questionnaire mis à jour dans vos « demandes en cours »."
    );
  };

  const saveBlockData = async (postData) => {
    return new Promise((resolve, reject) => {
      let path = `quotations/${state.rcproForm.apiData.quotationId}/finalized`;
      dataService.patch(path, postData, resolve, reject);
    });
  };

  return {
    updateFormData,
    updateErrors,
    updateHeadOfficeInfosInputs,
    updateGlobalInfosInputs,
    updateActiviteInputs,
    updateRCPROGlobalInfoInputs,
    updateRCPROSpecificInfoInputs,
    updateRCPROGlobalInfo2Inputs,
    updateRCPROCommentInputs,
    saveForm,
    initFormState,
    updateApiData,
    resetFormState,
  };
};
